const config = {
    "currentAcademicYearId": "66852c6bc3318994b46df17b",
    "baseName": '/wested',
    basePath: '',
    // "basePath": 'http://localhost:9415/wested/',
    "SUB_END_DATE": "2027-07-31T00:00:00.000+00:00",
    "LAST_YEAR_END_DATE" : "2024-07-31T00:00:00.000+00:00"
}

export default config;